<template lang="pug">
  div.wall2
    div.scale
      div.me(v-for="(n, i) in slititems", :style="sty(n)")
</template>

<script>
export default {
  name: 'ScaleFloor',
  components: {
  },
  data () {
    return {
    };
  },
  computed: {
  },
  methods: {
    sty (n) {
      return {
        bottom: (50 / 15) * n.pos + 'px'
      };
    }
  }
};
</script>

<style lang="stylus" scoped>
  .wall2
    position absolute
    left -30px
    bottom 0
    z-index 2
    .scale
      padding 0
      margin 0
      position relative
      .me
        width 14px
        height 2px
        background-color #000000
        position absolute
        left 0
        bottom 0
        transform translate(0,50%)
        &:last-child
          margin-bottom 0
</style>



// WEBPACK FOOTER //
// src/components/front/ScaleFloor.vue